<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        <span *ngIf="data.mesurementType === 'weekly'">
            Medida semanal
        </span>
        <span *ngIf="data.mesurementType === 'monthly'">
            Medida mensual
        </span>
        :{{data.indicator.indicator}}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="ngbActiveModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="indicatorForm">
        <div class="d-flex flex-row-reverse">
            <div class="form-group d-flex justify-content-end">
                <h3>Semana: {{currentWeek}} : {{currentMonth}}</h3>
<!--            <h3>{{startWeek}} - {{endWeek}} Semana: {{currentWeek}}</h3> -->
            </div>
        </div>
        <div class="form-group">
            <label for="indicatorFormResult" class="form-label">Resultado</label>
            <input type="number" class="form-control" id="indicatorFormResult" formControlName="result">
        </div>
        <p *ngIf="indicatorForm.controls['result'].touched && indicatorForm.controls['result'].invalid"
            class="text-danger">Este campo es requerido</p>
        <div class="form-group">
            <label for="indicatorObservation" class="form-label">Observaciones</label>
            <textarea type="text" class="form-control" id="indicatorObservation" formControlName="observation"
                rows="3"></textarea>
        </div>
        <div class="form-group">
            <label for="indicatorCause" class="form-label">Causa raíz</label>
            <textarea type="text" class="form-control" id="indicatorCause" formControlName="cause" rows="3"></textarea>
        </div>
        <input style="display: none;" type="file"  #fileCause
            (change)="uploadFile($event.target, 'urlFileCause', false)">
        <div class="d-grid gap-2">
            <button type="button" class="btn btn-info" (click)="fileCause.click()" [disabled]="isUploadingFile"
                ngbTooltip="Subir archivo">
                <span class="material-icons">
                    attach_file
                </span>
            </button>
        </div>
        <div class="progress" *ngIf="isUploadingFile && isCause">
            <div class="progress-bar bg-success" role="progressbar" [ngStyle]="{'width': currentPercentage + '%'}"
                aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="form-group">
                    <label for="indicatorPlan1" class="form-label">Acción 1</label>
                    <input type="text" class="form-control" id="indicatorPlan1" formControlName="plan1">
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="datePlan1" class="form-label">Fecha Acción 1</label>
                    <input type="date" class="form-control" id="datePlan1" formControlName="datePlan1">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="form-group">
                    <label for="indicatorPlan2" class="form-label">Acción 2</label>
                    <input type="text" class="form-control" id="indicatorPlan2" formControlName="plan2">
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="datePlan2" class="form-label">Fecha Acción 2</label>
                    <input type="date" class="form-control" id="datePlan2" formControlName="datePlan2">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="form-group">
                    <label for="indicatorPlan3" class="form-label">Acción 3</label>
                    <input type="text" class="form-control" id="indicatorPlan3" formControlName="plan3">
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="datePlan3" class="form-label">Fecha Acción 3</label>
                    <input type="date" class="form-control" id="datePlan3" formControlName="datePlan3">
                </div>
            </div>
        </div>
        <input style="display: none;" type="file"  #filePlan
            (change)="uploadFile($event.target, 'urlFilePlan', true)">
        <div class="d-grid gap-2">
            <button type="button" class="btn btn-info" (click)="filePlan.click()" [disabled]="isUploadingFile"
                ngbTooltip="Subir archivo">
                <span class="material-icons">
                    attach_file
                </span>
            </button>
        </div>
        <div class="progress" *ngIf="isUploadingFile && isPlan">
            <div class="progress-bar bg-success" role="progressbar" [ngStyle]="{'width': currentPercentage + '%'}"
                aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <div class="btn-group w-100 mt-5" role="group">
        <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="isSaving">
            <span>Cancelar</span>
        </button>
        <button type="button" class="btn btn-success" [disabled]="indicatorForm.invalid || isSaving" (click)="save()"
            ngbTooltip="{{indicatorForm.invalid ? 'Se necesitan todos los campos requeridos para poder guardar' : 'Guardar'}}">
            <span>Guardar</span>
            <div class="spinner-border" role="status" *ngIf="isSaving">
                <span class="visually-hidden"></span>
            </div>
        </button>
    </div>
</div>